export default {
  section1: [
    {
      name: "specializationContact0_firstName",
      label: "First name ",
      type: "textfield",
      fieldLableProps: { style: { fontSize: "13.5px" }, necessity: "required" },
      maxLength: 40,
      required: true,
      validator: "isString",
      placeholder: "Add",
      label_lang: "",
      key: "gov1_1",
      useLabel: true,
      rowStyle: { paddingBottom: "6%" },
    },
    {
      name: "specializationContact0_lastName",
      label: "Last name ",
      type: "textfield",
      fieldLableProps: { style: { fontSize: "13.5px" }, necessity: "required" },
      maxLength: 80,
      required: true,
      validator: "isString",
      placeholder: "Add",
      label_lang: "",
      rowStyle: { paddingBottom: "6%" },
      key: "gov1_2",
      useLabel: true,
    },
    {
      name: "specializationContact0_email",
      label: "Email address ",
      label_lang: "",
      type: "textfield",
      fieldLableProps: { style: { fontSize: "13.5px" }, necessity: "required" },
      required: true,
      maxLength: 80,
      validator: "isEmailDomain",
      placeholder: "Add",
      key: "gov1_3",
      useLabel: true,
    },
  ],
  section2: [
    [
      {
        name: "specializationContact1_firstName",
        label: "First Name ",
        type: "textfield",
        fieldLableProps: {
          style: { fontSize: "13.5px" },
          necessity: "required",
        },
        maxLength: 40,
        required: true,
        validator: "isString",
        placeholder: "Add",
        label_lang: "",
        key: "gov1_4",
        useLabel: true,
        rowStyle: { paddingBottom: "6%" },
      },
      {
        name: "specializationContact1_lastName",
        label: "Last Name ",
        type: "textfield",
        fieldLableProps: {
          style: { fontSize: "13.5px" },
          necessity: "required",
        },
        maxLength: 80,
        required: true,
        validator: "isString",
        placeholder: "Add",
        rowStyle: { paddingBottom: "6%" },
        label_lang: "",
        key: "gov1_5",
        useLabel: true,
      },
      {
        name: "specializationContact1_email",
        label: "Email address ",
        label_lang: "",
        maxLength: 80,
        type: "textfield",
        fieldLableProps: {
          style: { fontSize: "13.5px" },
          necessity: "required",
        },
        required: true,
        validator: "isEmailDomain",
        placeholder: "Add",
        key: "gov1_6",
        useLabel: true,
      },
    ],
    [
      {
        name: "specializationContact1_firstName",
        label: "First Name ",
        type: "textfield",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 40,
        validator: "isString",
        placeholder: "Add",
        label_lang: "",
        key: "gov1_4",
        useLabel: true,
        rowStyle: { paddingBottom: "6%" },
      },
      {
        name: "specializationContact1_lastName",
        label: "Last Name ",
        type: "textfield",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 80,
        validator: "isString",
        placeholder: "Add",
        rowStyle: { paddingBottom: "6%" },
        label_lang: "",
        key: "gov1_5",
        useLabel: true,
      },
      {
        name: "specializationContact1_email",
        label: "Email address ",
        label_lang: "",
        maxLength: 80,
        type: "textfield",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        validator: "isEmailDomain",
        placeholder: "Add",
        key: "gov1_6",
        useLabel: true,
      },
    ],
  ],

  section3: [
    {
      name: "qt_1_textAreaAnswer",
      label: "Company Website",
      type: "textfield",
      fieldLableProps: { style: { fontSize: "13.5px" }, necessity: "required" },
      rowStyle: { paddingBottom: "5%" },
      maxLength: 81,
      validator: "isString",
      required: true,
      placeholder: "Add",
      label_lang: "",
      key: "gov3_1",
      useLabel: true,
    },
    {
      name: "qt_15_textAreaAnswer",
      label: "Years in business",
      type: "textfield",
      fieldLableProps: { style: { fontSize: "13.5px" }, necessity: "required" },
      maxLength: 4,
      required: true,
      validator: "isString",
      rowStyle: { paddingBottom: "5%" },
      placeholder: "Add",
      label_lang: "",
      key: "gov3_2",
      useLabel: true,
    },
    {
      name: "qt_27_textAreaAnswer",
      label: "Total number of offices",
      type: "textfield",
      fieldLableProps: { style: { fontSize: "13.5px" }, necessity: "required" },
      maxLength: 80,
      required: true,
      validator: "isString",
      placeholder: "Add",
      label_lang: "",
      key: "gov3_3",
      useLabel: true,
    },
  ],

  section4: [
    {
      name: "qt_32_answer1",
      label: "Sales",
      type: "textfield",
      fieldLableProps: { style: { fontSize: "13.5px" } },
      maxLength: 80,
      required: true,
      validator: "isString",
      placeholder: "Add",
      label_lang: "",
      key: "gov4_1",
      useLabel: true,
    },
  ],
  section5: [
    {
      name: "qt_32_answer2",
      label: "Technical",
      type: "textfield",
      fieldLableProps: { style: { fontSize: "13.5px" } },
      maxLength: 80,
      required: true,
      validator: "isString",
      placeholder: "Add",
      label_lang: "",
      key: "gov5_1",
      useLabel: true,
    },
  ],
  section6: [
    {
      name: "qt_32_answer3",
      label: "Marketing/Other",
      type: "textfield",
      fieldLableProps: { style: { fontSize: "13.5px" } },
      maxLength: 80,
      required: true,
      validator: "isString",
      placeholder: "Add",
      label_lang: "",
      key: "gov6_1",
      useLabel: true,
    },
  ],
  section7: [
    {
      name: "qt_32_answer4",
      label: "Total",
      type: "textfield",
      fieldLableProps: { style: { fontSize: "13.5px" } },
      maxLength: 80,
      required: true,
      validator: "isString",
      placeholder: "Add",
      label_lang: "",
      key: "gov7_1",
      useLabel: true,
    },
  ],
  section8: [
    [
      {
        name: "qt-34-answer1-0",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        placeholder: "Name",
        maxLength: 40,
        required: true,
        validator: "isString",
        key: "gov8_1c0",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-34-answer2-0",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 80,
        placeholder: "Title",
        required: true,
        validator: "isString",
        key: "gov8_2c0",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-34-answer9-0",
        type: "textfield",
        label: "",
        maxLength: 80,
        fieldLableProps: { style: { fontSize: "13.5px" } },
        required: true,
        validator: "isValidPhoneNumber",
        placeholder: "Phone",
        key: "gov8_3c0",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-34-answer10-0",
        type: "textfield",
        label: "",
        maxLength: 80,
        fieldLableProps: { style: { fontSize: "13.5px" } },
        required: true,
        validator: "isEmail",
        placeholder: "Email address",
        key: "gov8_4c0",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-34-answer3-0",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 80,
        required: true,
        validator: "isString",
        placeholder: "Address line 1",
        key: "gov8_5c0",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-34-answer4-0",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 80,
        placeholder: "Address line 2",
        key: "gov8_6c0",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-34-answer5-0",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 40,
        required: true,
        validator: "isString",
        placeholder: "City",
        key: "gov8_7c0",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-34-answer6-0",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 40,
        required: true,
        validator: "isString",
        placeholder: "State/Province",
        key: "gov8_8c0",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-34-answer7-0",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 20,
        required: true,
        validator: "isString",
        placeholder: "Postal Code",
        key: "gov8_9c0",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-34-answer8-0",
        type: "textfield",
        label: "",
        maxLength: 80,
        fieldLableProps: { style: { fontSize: "13.5px" } },
        key: "gov8_10c0",
        required: true,
        validator: "isString",
        placeholder: "Country",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
    ],
    [
      {
        name: "qt-34-answer1-1",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        placeholder: "Name",
        maxLength: 40,
        required: true,
        validator: "isString",
        key: "gov8_1c1",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-34-answer2-1",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 80,
        placeholder: "Title",
        required: true,
        validator: "isString",
        key: "gov8_2c1",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-34-answer9-1",
        type: "textfield",
        label: "",
        maxLength: 80,
        fieldLableProps: { style: { fontSize: "13.5px" } },
        required: true,
        validator: "isValidPhoneNumber",
        placeholder: "Phone",
        key: "gov8_3c1",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-34-answer10-1",
        type: "textfield",
        label: "",
        maxLength: 80,
        fieldLableProps: { style: { fontSize: "13.5px" } },
        required: true,
        validator: "isEmail",
        placeholder: "Email address",
        key: "gov8_4c1",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-34-answer3-1",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 80,
        required: true,
        validator: "isString",
        placeholder: "Address line 1",
        key: "gov8_5c1",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-34-answer4-1",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 80,
        placeholder: "Address line 2",
        key: "gov8_6c1",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-34-answer5-1",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 40,
        required: true,
        validator: "isString",
        placeholder: "City",
        key: "gov8_7c1",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-34-answer6-1",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 40,
        required: true,
        validator: "isString",
        placeholder: "State/Province",
        key: "gov8_8c1",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-34-answer7-1",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 20,
        required: true,
        validator: "isString",
        placeholder: "Postal Code",
        key: "gov8_9c1",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-34-answer8-1",
        type: "textfield",
        label: "",
        maxLength: 80,
        fieldLableProps: { style: { fontSize: "13.5px" } },
        key: "gov8_10c1",
        required: true,
        validator: "isString",
        placeholder: "Country",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
    ],

    [
      {
        name: "qt-34-answer1-2",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        placeholder: "Name",
        maxLength: 40,
        required: true,
        validator: "isString",
        key: "gov8_1c2",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-34-answer2-2",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 80,
        placeholder: "Title",
        required: true,
        validator: "isString",
        key: "gov8_2c2",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-34-answer9-2",
        type: "textfield",
        label: "",
        maxLength: 80,
        fieldLableProps: { style: { fontSize: "13.5px" } },
        required: true,
        validator: "isValidPhoneNumber",
        placeholder: "Phone",
        key: "gov8_3c2",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-34-answer10-2",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        required: true,
        maxLength: 80,
        validator: "isEmail",
        placeholder: "Email address",
        key: "gov8_4c2",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-34-answer3-2",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 80,
        required: true,
        validator: "isString",
        placeholder: "Address line 1",
        key: "gov8_5c2",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-34-answer4-2",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 80,
        placeholder: "Address line 2",
        key: "gov8_6c2",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-34-answer5-2",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 40,
        required: true,
        validator: "isString",
        placeholder: "City",
        key: "gov8_7c2",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-34-answer6-2",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 40,
        required: true,
        validator: "isString",
        placeholder: "State/Province",
        key: "gov8_8c2",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-34-answer7-2",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 20,
        required: true,
        validator: "isString",
        placeholder: "Postal Code",
        key: "gov8_9c2",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-34-answer8-2",
        type: "textfield",
        label: "",
        maxLength: 80,
        fieldLableProps: { style: { fontSize: "13.5px" } },
        key: "gov8_10c2",
        required: true,
        validator: "isString",
        placeholder: "Country",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
    ],
    [
      {
        name: "qt-34-answer1-3",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        placeholder: "Name",
        maxLength: 40,
        required: true,
        validator: "isString",
        key: "gov8_1c3",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-34-answer2-3",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 80,
        placeholder: "Title",
        required: true,
        validator: "isString",
        key: "gov8_2c3",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-34-answer9-3",
        type: "textfield",
        label: "",
        maxLength: 80,
        fieldLableProps: { style: { fontSize: "13.5px" } },
        required: true,
        validator: "isValidPhoneNumber",
        placeholder: "Phone",
        key: "gov8_3c3",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-34-answer10-3",
        type: "textfield",
        label: "",
        maxLength: 80,
        fieldLableProps: { style: { fontSize: "13.5px" } },
        required: true,
        validator: "isEmail",
        placeholder: "Email address",
        key: "gov8_4c3",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-34-answer3-3",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 80,
        required: true,
        validator: "isString",
        placeholder: "Address line 1",
        key: "gov8_5c3",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-34-answer4-3",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 80,
        placeholder: "Address line 2",
        key: "gov8_6c3",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-34-answer5-3",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 40,
        required: true,
        validator: "isString",
        placeholder: "City",
        key: "gov8_7c3",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-34-answer6-3",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 40,
        required: true,
        validator: "isString",
        placeholder: "State/Province",
        key: "gov8_8c3",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-34-answer7-3",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 20,
        required: true,
        validator: "isString",
        placeholder: "Postal Code",
        key: "gov8_9c3",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-34-answer8-3",
        type: "textfield",
        label: "",
        maxLength: 80,
        fieldLableProps: { style: { fontSize: "13.5px" } },
        key: "gov8_10c3",
        required: true,
        validator: "isString",
        placeholder: "Country",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
    ],
  ],
  section9: [
    {
      type: "radiogroup",
      fieldLableProps: {
        style: { color: "#323232", fontSize: "16.5px" },
        necessity: "required",
      },
      name: "qt_36_ynu",
      required: true,
      validator: "isString",
      label:
        "Do you have a dedicated government contracting group or access to a specialty firm for government contacting?",
      useLabel: true,
      key: "gov9_1",
      rowStyle: { paddingBottom: "2%", paddingTop: "0.5%" },
      radios: [
        {
          label: "Yes",
          value: "Yes",
          type: "radio",
          useLabel: true,
        },
        {
          label: "No",
          value: "No",
          type: "radio",
          useLabel: true,
        },
      ],
      actions: [
        {
          fieldName: "qt-36-answer1",
          resetRequired: true,
          untouchRequired: true,
          resetValue: null,
        },
        {
          fieldName: "qt-36-answer2",
          resetRequired: true,
          untouchRequired: true,
          resetValue: null,
        },
        {
          fieldName: "qt-36-answer3",
          resetRequired: true,
          untouchRequired: true,
          resetValue: null,
        },
        {
          fieldName: "qt-36-answer4",
          resetRequired: true,
          untouchRequired: true,
          resetValue: null,
        },
        {
          fieldName: "qt-36-answer5",
          resetRequired: true,
          untouchRequired: true,
          resetValue: null,
        },
        {
          fieldName: "qt-36-answer6",
          resetRequired: true,
          untouchRequired: true,
          resetValue: null,
        },
        {
          fieldName: "qt-36-answer7",
          resetRequired: true,
          untouchRequired: true,
          resetValue: null,
        },
        {
          fieldName: "qt-36-answer8",
          resetRequired: true,
          untouchRequired: true,
          resetValue: null,
        },
        {
          fieldName: "qt-36-answer9",
          resetRequired: true,
          untouchRequired: true,
          resetValue: null,
        },
        {
          fieldName: "qt-36-answer10",
          resetRequired: true,
          untouchRequired: true,
          resetValue: null,
        },
        {
          fieldName: "qt-36-answer11",
          resetRequired: true,
          untouchRequired: true,
          resetValue: null,
        },
      ],
    },
    {
      type: "radiogroup",
      fieldLableProps: {
        style: { color: "#323232", fontSize: "16.5px" },
        necessity: "required",
      },
      name: "qt_38_ynu",
      required: true,
      validator: "isString",
      label:
        "Do you have previous or current agreement with Adobe or an acquired company (eg. Omniture)?",
      useLabel: true,
      key: "gov9_2",
      radios: [
        {
          label: "Yes",
          value: "Yes",
          type: "radio",
          useLabel: true,
        },
        {
          label: "No",
          value: "No",
          type: "radio",
          useLabel: true,
        },
      ],
      actions: [
        {
          fieldName: "qt-38-checkboxAnswer",
          resetRequired: true,
          untouchRequired: true,
          resetValue: null,
        },
      ],
    },
  ],
  section10: [
    {
      name: "gov10_1",
      type: "divwithspan",
      key: "gov10_1",
      value: "Name",
      divStyle: { height: "42.2px", paddingTop: "3px" },
      spanStyle: { color: "#747474" },
    },
    {
      name: "gov10_2",
      type: "divwithspan",
      key: "gov10_2",
      value: "Title",
      divStyle: { height: "42.2px" },
      spanStyle: { color: "#747474" },
    },
    {
      name: "gov10_3",
      type: "divwithspan",
      key: "gov10_3",
      value: "Phone",
      divStyle: { height: "42.2px" },
      spanStyle: { color: "#747474" },
    },
    {
      name: "gov10_4",
      type: "divwithspan",
      key: "gov10_4",
      value: "Email address",
      divStyle: { height: "42.2px" },
      spanStyle: { color: "#747474" },
    },
    {
      name: "gov10_5",
      type: "divwithspan",
      key: "gov10_5",
      value: "Address line 1",
      divStyle: { height: "42.2px" },
      spanStyle: { color: "#747474" },
    },
    {
      name: "gov10_6",
      type: "divwithspan",
      key: "gov10_6",
      value: "Address line 2",
      divStyle: { height: "42.2px" },
      spanStyle: { color: "#747474" },
    },
    {
      name: "gov10_7",
      type: "divwithspan",
      key: "gov10_7",
      value: "City",
      divStyle: { height: "42.2px" },
      spanStyle: { color: "#747474" },
    },
    {
      name: "gov10_8",
      type: "divwithspan",
      key: "gov10_8",
      value: "State/Province",
      divStyle: { height: "42.2px" },
      spanStyle: { color: "#747474" },
    },
    {
      name: "gov10_9",
      type: "divwithspan",
      key: "gov10_9",
      value: "Postal code",
      divStyle: { height: "42.2px" },
      spanStyle: { color: "#747474" },
    },
    {
      name: "gov10_10",
      type: "divwithspan",
      key: "gov10_10",
      value: "Country",
      divStyle: { height: "42.2px" },
      spanStyle: { color: "#747474" },
    },
  ],

  section11: [
    {
      type: "radiogroup",
      name: "qt_41_radioAnswer",
      required: true,
      key: "gov11_1",
      validator: "isString",
      fieldLableProps: {
        style: { color: "#323232", fontSize: "16.5px" },
        necessity: "required",
      },
      label: "What best describes your company?",
      vertical: true,
      useLabel: true,
      radios: [
        {
          label: "Sole Proprietor",
          value: "Sole Proprietor",
          type: "radio",
          useLabel: true,
        },
        {
          label: "Partnership",
          value: "Partnership",
          type: "radio",
          useLabel: true,
        },
        {
          label: "Subsidiary",
          value: "Subsidiary",
          type: "radio",
          useLabel: true,
        },
        {
          label: "Franchise",
          value: "Franchise",
          type: "radio",
          useLabel: true,
        },
        {
          label: "Corporation",
          value: "Corporation",
          type: "radio",
          useLabel: true,
        },
      ],
    },
  ],
  section12: [
    {
      name: "qt_3_textAreaAnswer",
      label: "State of incorporation",
      type: "textfield",
      fieldLableProps: { style: { fontSize: "13.5px" } },
      maxLength: 66,
      validator: "isString",
      placeholder: "Add",
      label_lang: "",
      key: "gov12_1",
      useLabel: true,
      rowStyle: { paddingBottom: "3.5%" },
    },
    {
      name: "qt_5_textAreaAnswer",
      label: "Parent corporation or franchiser",
      type: "textfield",
      fieldLableProps: { style: { fontSize: "13.5px" } },
      maxLength: 66,
      validator: "isString",
      placeholder: "Add",
      label_lang: "",
      key: "gov12_2",
      useLabel: true,
    },
  ],
  section13: [
    {
      name: "st_7_8(a)",
      label: "8(a)",
      type: "checkbox",
      style: { marginTop: "5px" },
      key: "gov13_1",
      useLabel: false,
      fieldLableProps: { style: { padding: "0px 0 0px" } },
    },
    {
      name: "st_7_SDB",
      label: "SDB",
      type: "checkbox",
      style: { marginTop: "5px" },
      key: "gov13_2",
      useLabel: false,
      fieldLableProps: { style: { padding: "0px 0 0px" } },
    },
    {
      name: "st_7_AK/Tribal",
      label: "AK/Tribal",
      type: "checkbox",
      style: { marginTop: "5px" },
      key: "gov13_3",
      useLabel: false,
      fieldLableProps: { style: { padding: "0px 0 0px" } },
    },
    {
      name: "st_7_SBA",
      label: "SBA",
      type: "checkbox",
      style: { marginTop: "5px" },
      key: "gov13_4",
      useLabel: false,
      fieldLableProps: { style: { padding: "0px 0 0px" } },
    },
    {
      name: "st_7_MBE/WBE",
      label: "MBE/WBE",
      type: "checkbox",
      style: { marginTop: "5px" },
      key: "gov13_5",
      useLabel: false,
      fieldLableProps: { style: { padding: "0px 0 0px" } },
    },
    {
      name: "st_7_Hubzone",
      label: "Hubzone",
      type: "checkbox",
      style: { marginTop: "5px" },
      key: "gov13_6",
      useLabel: false,
      fieldLableProps: { style: { padding: "0px 0 0px" } },
    },
    {
      name: "st_7_None",
      label: "None of the above",
      type: "checkbox",
      style: { marginTop: "5px" },
      key: "gov13_7",
      useLabel: false,
      fieldLableProps: { style: { padding: "0px 0 0px" } },
    },
  ],

  section14: [
    {
      name: "qt_8_textAreaAnswer",
      label:
        "Please list all company and individual government clearances (facility and personnel, including clearance levels).",
      type: "textarea",
      fieldLableProps: {
        style: { color: "#323232", fontSize: "16.5px" },
        necessity: "required",
      },
      maxLength: 15000,
      required: true,
      validator: "isString",
      placeholder: "Add",
      label_lang: "",
      key: "gov14_1",
      useLabel: true,
    },
  ],
  section15: [
    {
      name: "qt_9_textAreaAnswer",
      label:
        "Please describe your company’s value add below. Include in your description what your solution is and how it benefits end users. Describe how Adobe products will be part of this solution. (50 words or fewer).",
      type: "textarea",
      fieldLableProps: {
        style: { color: "#323232", fontSize: "16.5px" },
        necessity: "required",
      },
      maxLength: 15000,
      required: true,
      validator: "isString",
      placeholder: "Add",
      label_lang: "",
      key: "gov15_1",
      useLabel: true,
    },
  ],
  section16: [
    {
      name: "qt_11_textAreaAnswer",
      label: "$",
      type: "textfield",
      maxLength: 20,
      required: true,
      validator: "isString",
      style: { width: "80%" },
      fieldLableProps: { position: "left", style: { fontSize: "13.5px" } },
      placeholder: "Add",
      key: "gov16",
      useLabel: true,
    },
  ],
  section17: [
    {
      name: "qt_12_answer1",
      label: "Hardware Systems/Peripherals",
      type: "textfield",
      fieldLableProps: { style: { fontSize: "13.5px" } },
      rowStyle: { paddingBottom: "8%" },
      style: { width: "90%" },
      maxLength: 3,
      required: true,
      validator: "isString",
      placeholder: "%",
      key: "gov17_1",
      useLabel: true,
    },
    {
      name: "qt_12_answer2",
      label: "Vertical Software",
      type: "textfield",
      fieldLableProps: { style: { fontSize: "13.5px" } },
      rowStyle: { paddingBottom: "8%" },
      style: { width: "90%" },
      maxLength: 3,
      required: true,
      validator: "isString",
      placeholder: "%",
      key: "gov17_2",
      useLabel: true,
    },
  ],
  section18: [
    {
      name: "qt_12_answer3",
      label: "Horizontal Software",
      type: "textfield",
      fieldLableProps: { style: { fontSize: "13.5px" } },
      rowStyle: { paddingBottom: "8%" },
      style: { width: "90%" },
      maxLength: 3,
      required: true,
      validator: "isString",
      placeholder: "%",
      key: "gov18",
      useLabel: true,
    },
    {
      name: "qt_12_answer4",
      label: "Integration",
      type: "textfield",
      fieldLableProps: { style: { fontSize: "13.5px" } },
      rowStyle: { paddingBottom: "8%" },
      style: { width: "90%" },
      maxLength: 3,
      required: true,
      validator: "isString",
      placeholder: "%",
      key: "gov18_2",
      useLabel: true,
    },
  ],
  section19: [
    {
      name: "qt_12_answer5",
      label: "Consulting",
      type: "textfield",
      fieldLableProps: { style: { fontSize: "13.5px" } },
      rowStyle: { paddingBottom: "8%" },
      style: { width: "90%" },
      maxLength: 3,
      required: true,
      validator: "isString",
      placeholder: "%",
      key: "gov19",
      useLabel: true,
    },
    {
      name: "qt_12_answer6",
      label: "Hosting/Service",
      type: "textfield",
      fieldLableProps: { style: { fontSize: "13.5px" } },
      rowStyle: { paddingBottom: "8%" },
      style: { width: "90%" },
      maxLength: 3,
      required: true,
      validator: "isString",
      placeholder: "%",
      key: "gov19_2",
      useLabel: true,
    },
  ],
  section20: [
    {
      name: "qt_12_answer7",
      label: "Maintenance",
      type: "textfield",
      fieldLableProps: { style: { fontSize: "13.5px" } },
      rowStyle: { paddingBottom: "8%" },
      style: { width: "90%" },
      maxLength: 3,
      required: true,
      validator: "isString",
      placeholder: "%",
      key: "gov20",
      useLabel: true,
    },
    {
      name: "qt_12_answer8",
      label: "Other",
      type: "textfield",
      fieldLableProps: { style: { fontSize: "13.5px" } },
      rowStyle: { paddingBottom: "8%" },
      style: { width: "90%" },
      maxLength: 3,
      required: true,
      validator: "isString",
      placeholder: "%",
      key: "gov20_2",
      useLabel: true,
    },
  ],
  section21: [
    {
      name: "qt_13_answer1",
      label: "Small Business (<$50m in sales)",
      type: "textfield",
      fieldLableProps: { style: { fontSize: "13.5px" } },
      rowStyle: { paddingBottom: "8%" },
      style: { width: "90%" },
      maxLength: 3,
      required: true,
      validator: "isString",
      placeholder: "%",
      key: "gov21",
      useLabel: true,
    },
    {
      name: "qt_13_answer2",
      label: "Medium Business ($50m - $500m)",
      type: "textfield",
      fieldLableProps: { style: { fontSize: "13.5px" } },
      rowStyle: { paddingBottom: "8%" },
      style: { width: "90%" },
      maxLength: 3,
      required: true,
      validator: "isString",
      placeholder: "%",
      key: "gov21_1",
      useLabel: true,
    },
  ],
  section22: [
    {
      name: "qt_13_answer3",
      label: "Large Business (>$500m)",
      type: "textfield",
      fieldLableProps: { style: { fontSize: "13.5px" } },
      rowStyle: { paddingBottom: "8%" },
      style: { width: "90%" },
      maxLength: 3,
      required: true,
      validator: "isString",
      placeholder: "%",
      key: "gov22_1",
      useLabel: true,
    },
    {
      name: "qt_13_answer4",
      label: "Federal Government",
      type: "textfield",
      fieldLableProps: { style: { fontSize: "13.5px" } },
      rowStyle: { paddingBottom: "8%" },
      style: { width: "90%" },
      maxLength: 3,
      required: true,
      validator: "isString",
      placeholder: "%",
      key: "gov22_2",
      useLabel: true,
    },
  ],
  section23: [
    {
      name: "qt_13_answer5",
      label: "State/Provincial Government",
      type: "textfield",
      fieldLableProps: { style: { fontSize: "13.5px" } },
      rowStyle: { paddingBottom: "8%" },
      style: { width: "90%" },
      maxLength: 3,
      required: true,
      validator: "isString",
      placeholder: "%",
      key: "gov23_1",
      useLabel: true,
    },
    {
      name: "qt_13_answer6",
      label: "Local/Municipal Government",
      type: "textfield",
      fieldLableProps: { style: { fontSize: "13.5px" } },
      rowStyle: { paddingBottom: "8%" },
      style: { width: "90%" },
      maxLength: 3,
      required: true,
      validator: "isString",
      placeholder: "%",
      key: "gov23_2",
      useLabel: true,
    },
  ],
  section24: [
    {
      name: "qt_13_answer7",
      label: "Education",
      type: "textfield",
      fieldLableProps: { style: { fontSize: "13.5px" } },
      rowStyle: { paddingBottom: "8%" },
      style: { width: "90%" },
      maxLength: 3,
      required: true,
      validator: "isString",
      placeholder: "%",
      key: "gov24_1",
      useLabel: true,
    },
    {
      name: "qt_13_answer8",
      label: "Non-profit Organizations",
      type: "textfield",
      fieldLableProps: { style: { fontSize: "13.5px" } },
      rowStyle: { paddingBottom: "8%" },
      style: { width: "90%" },
      maxLength: 3,
      required: true,
      validator: "isString",
      placeholder: "%",
      key: "gov24_2",
      useLabel: true,
    },
  ],
  section25: [
    [
      {
        name: "qt_14_answer1",
        type: "textfield",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        label: "Vendor",
        placeholder: "Add",
        key: "gov25_1",
        validator: "isString",
        rowStyle: { paddingBottom: "7.6%" },
        maxLength: 80,
        required: true,
        useLabel: true,
      },
      {
        name: "qt_14_answer2",
        type: "textfield",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        label: "Product Line",
        placeholder: "Add",
        key: "gov25_2",
        validator: "isString",
        rowStyle: { paddingBottom: "7.6%" },
        maxLength: 80,
        required: true,
        useLabel: true,
      },
      {
        name: "qt_14_answer3",
        label: "%Sales",
        type: "textfield",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 3,
        required: true,
        validator: "isString",
        rowStyle: { paddingBottom: "7.6%" },
        placeholder: "%",
        key: "gov25_3",
        useLabel: true,
      },
    ],
    [
      {
        name: "qt_14_answer4",
        type: "textfield",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        label: "Vendor",
        placeholder: "Add",
        key: "gov25_1",
        validator: "isString",
        rowStyle: { paddingBottom: "7.6%" },
        maxLength: 80,
        required: true,
        useLabel: true,
      },
      {
        name: "qt_14_answer5",
        type: "textfield",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        label: "Product Line",
        placeholder: "Add",
        key: "gov25_2",
        validator: "isString",
        rowStyle: { paddingBottom: "7.6%" },
        maxLength: 80,
        required: true,
        useLabel: true,
      },
      {
        name: "qt_14_answer6",
        label: "%Sales",
        type: "textfield",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 3,
        required: true,
        validator: "isString",
        rowStyle: { paddingBottom: "7.6%" },
        placeholder: "%",
        key: "gov25_3",
        useLabel: true,
      },
    ],
    [
      {
        name: "qt_14_answer7",
        type: "textfield",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        label: "Vendor",
        placeholder: "Add",
        key: "gov25_1",
        validator: "isString",
        rowStyle: { paddingBottom: "7.6%" },
        maxLength: 80,
        required: true,
        useLabel: true,
      },
      {
        name: "qt_14_answer8",
        type: "textfield",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        label: "Product Line",
        placeholder: "Add",
        key: "gov25_2",
        validator: "isString",
        rowStyle: { paddingBottom: "7.6%" },
        maxLength: 80,
        required: true,
        useLabel: true,
      },
      {
        name: "qt_14_answer9",
        label: "%Sales",
        type: "textfield",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 3,
        required: true,
        validator: "isString",
        rowStyle: { paddingBottom: "7.6%" },
        placeholder: "%",
        key: "gov25_3",
        useLabel: true,
      },
    ],
  ],
  section26: [
    [
      {
        name: "qt_17_answer4",
        label: "Market",
        type: "select",
        required: true,
        placeholder: "Select",
        rowStyle: { paddingBottom: "6%" },
        fieldLableProps: { style: { fontSize: "13.5px" } },
        key: "gov26_1",
        useLabel: true,
        options: [
          {
            label: "None",
            value: "None",
          },
          {
            label: "OtherManufacturing",
            value: "OtherManufacturing",
          },
          {
            label: "Government – Civilian Government – Defense",
            value: "Government – Civilian Government – Defense",
          },
          {
            label: "Government – Intelligence",
            value: "Government – Intelligence",
          },
          {
            label: "Pharmaceuticals/Chemicals",
            value: "Pharmaceuticals/Chemicals",
          },
          {
            label: "Publishing",
            value: "Publishing",
          },
          {
            label: "Banking",
            value: "Banking",
          },
          {
            label: "Research",
            value: "Research",
          },
          {
            label: "Broadcast/Communication",
            value: "Broadcast/Communication",
          },
          {
            label: "Retail/Wholesale",
            value: "Retail/Wholesale",
          },
          {
            label: "Healthcare/Services",
            value: "Healthcare/Services",
          },
          {
            label: "Insurance",
            value: "Insurance",
          },
          {
            label: "State/Local Government",
            value: "State/Local Government",
          },
          {
            label: "Internet/Intranet",
            value: "Internet/Intranet",
          },
          {
            label: "Telecom",
            value: "Telecom",
          },
          {
            label: "Education",
            value: "Education",
          },
          {
            label: "Legal",
            value: "Legal",
          },
          {
            label: "Other",
            value: "Other",
          },
        ],
      },
      {
        name: "qt_17_answer1",
        label: "Market revenue",
        type: "textfield",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 3,
        required: true,
        validator: "isString",
        rowStyle: { paddingBottom: "6%" },
        placeholder: "%",
        key: "gov26_2",
        useLabel: true,
      },
    ],
    [
      {
        name: "qt_17_answer5",
        label: "Market",
        type: "select",
        required: true,
        placeholder: "Select",
        rowStyle: { paddingBottom: "6%" },
        fieldLableProps: { style: { fontSize: "13.5px" } },
        key: "gov26_1",
        useLabel: true,
        options: [
          {
            label: "None",
            value: "None",
          },
          {
            label: "OtherManufacturing",
            value: "OtherManufacturing",
          },
          {
            label: "Government – Civilian Government – Defense",
            value: "Government – Civilian Government – Defense",
          },
          {
            label: "Government – Intelligence",
            value: "Government – Intelligence",
          },
          {
            label: "Pharmaceuticals/Chemicals",
            value: "Pharmaceuticals/Chemicals",
          },
          {
            label: "Publishing",
            value: "Publishing",
          },
          {
            label: "Banking",
            value: "Banking",
          },
          {
            label: "Research",
            value: "Research",
          },
          {
            label: "Broadcast/Communication",
            value: "Broadcast/Communication",
          },
          {
            label: "Retail/Wholesale",
            value: "Retail/Wholesale",
          },
          {
            label: "Healthcare/Services",
            value: "Healthcare/Services",
          },
          {
            label: "Insurance",
            value: "Insurance",
          },
          {
            label: "State/Local Government",
            value: "State/Local Government",
          },
          {
            label: "Internet/Intranet",
            value: "Internet/Intranet",
          },
          {
            label: "Telecom",
            value: "Telecom",
          },
          {
            label: "Education",
            value: "Education",
          },
          {
            label: "Legal",
            value: "Legal",
          },
          {
            label: "Other",
            value: "Other",
          },
        ],
      },
      {
        name: "qt_17_answer2",
        label: "Market revenue",
        type: "textfield",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 3,
        required: true,
        validator: "isString",
        rowStyle: { paddingBottom: "6%" },
        placeholder: "%",
        key: "gov26_2",
        useLabel: true,
      },
    ],
    [
      {
        name: "qt_17_answer6",
        label: "Market",
        type: "select",
        required: true,
        placeholder: "Select",
        rowStyle: { paddingBottom: "6%" },
        fieldLableProps: { style: { fontSize: "13.5px" } },
        key: "gov26_1",
        useLabel: true,
        options: [
          {
            label: "None",
            value: "None",
          },
          {
            label: "OtherManufacturing",
            value: "OtherManufacturing",
          },
          {
            label: "Government – Civilian Government – Defense",
            value: "Government – Civilian Government – Defense",
          },
          {
            label: "Government – Intelligence",
            value: "Government – Intelligence",
          },
          {
            label: "Pharmaceuticals/Chemicals",
            value: "Pharmaceuticals/Chemicals",
          },
          {
            label: "Publishing",
            value: "Publishing",
          },
          {
            label: "Banking",
            value: "Banking",
          },
          {
            label: "Research",
            value: "Research",
          },
          {
            label: "Broadcast/Communication",
            value: "Broadcast/Communication",
          },
          {
            label: "Retail/Wholesale",
            value: "Retail/Wholesale",
          },
          {
            label: "Healthcare/Services",
            value: "Healthcare/Services",
          },
          {
            label: "Insurance",
            value: "Insurance",
          },
          {
            label: "State/Local Government",
            value: "State/Local Government",
          },
          {
            label: "Internet/Intranet",
            value: "Internet/Intranet",
          },
          {
            label: "Telecom",
            value: "Telecom",
          },
          {
            label: "Education",
            value: "Education",
          },
          {
            label: "Legal",
            value: "Legal",
          },
          {
            label: "Other",
            value: "Other",
          },
        ],
      },
      {
        name: "qt_17_answer3",
        label: "Market revenue",
        type: "textfield",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 3,
        required: true,
        validator: "isString",
        rowStyle: { paddingBottom: "6%" },
        placeholder: "%",
        key: "gov26_2",
        useLabel: true,
      },
    ],
  ],
  section27: [
    {
      name: "st_18_Central Intelligence Agency",
      label: "Central Intelligence Agency",
      type: "checkbox",
      fieldLableProps: { style: { padding: "0px 0 0px" } },
      key: "gov27_1",
      useLabel: false,
    },
    {
      name: "st_18_Defense Intelligence Agency",
      label: "Defense Intelligence Agency",
      type: "checkbox",
      fieldLableProps: { style: { padding: "0px 0 0px" } },
      key: "gov27_2",
      useLabel: false,
    },
    {
      name: "st_18_Department of Agriculture",
      label: "Department of Agriculture",
      type: "checkbox",
      fieldLableProps: { style: { padding: "0px 0 0px" } },
      key: "gov27_3",
      useLabel: false,
    },
    {
      name: "st_18_Department of Commerce",
      label: "Department of Commerce",
      type: "checkbox",
      fieldLableProps: { style: { padding: "0px 0 0px" } },
      key: "gov27_4",
      useLabel: false,
    },
    {
      name: "st_18_Department of Education",
      label: "Department of Education",
      type: "checkbox",
      fieldLableProps: { style: { padding: "0px 0 0px" } },
      key: "gov27_5",
      useLabel: false,
    },
    {
      name: "st_18_Department of Energy",
      label: "Department of Energy",
      type: "checkbox",
      fieldLableProps: { style: { padding: "0px 0 0px" } },
      key: "gov27_6",
      useLabel: false,
    },
    {
      name: "st_18_Department of Health/Human Resources",
      label: "Department of Health/Human Resources",
      type: "checkbox",
      fieldLableProps: { style: { padding: "0px 0 0px" } },
      key: "gov27_7",
      useLabel: false,
    },
    {
      name: "st_18_Department of Interior",
      label: "Department of Interior",
      type: "checkbox",
      fieldLableProps: { style: { padding: "0px 0 0px" } },
      key: "gov27_8",
      useLabel: false,
    },
    {
      name: "st_18_Department of Labor",
      label: "Department of Labor",
      type: "checkbox",
      fieldLableProps: { style: { padding: "0px 0 0px" } },
      key: "gov27_9",
      useLabel: false,
    },
    {
      name: "st_18_Department of Navy",
      label: "Department of Navy",
      type: "checkbox",
      fieldLableProps: { style: { padding: "0px 0 0px" } },
      key: "gov27_10",
      useLabel: false,
    },
  ],
  section28: [
    {
      name: "st_18_Department of the Air Force",
      label: "Department of the Air Force",
      type: "checkbox",
      fieldLableProps: { style: { padding: "0px 0 0px" } },
      key: "gov28_1",
      useLabel: false,
    },
    {
      name: "st_18_Department of the Army",
      label: "Department of the Army",
      type: "checkbox",
      fieldLableProps: { style: { padding: "0px 0 0px" } },
      key: "gov28_2",
      useLabel: false,
    },
    {
      name: "st_18_Department of Transportation",
      label: "Department of Transportation",
      type: "checkbox",
      fieldLableProps: { style: { padding: "0px 0 0px" } },
      key: "gov28_3",
      useLabel: false,
    },
    {
      name: "st_18_Department of Veteran Affairs",
      label: "Department of Veteran Affairs",
      type: "checkbox",
      fieldLableProps: { style: { padding: "0px 0 0px" } },
      key: "gov28_4",
      useLabel: false,
    },
    {
      name: "st_18_Drug Enforcement Agency",
      label: "Drug Enforcement Agency",
      type: "checkbox",
      fieldLableProps: { style: { padding: "0px 0 0px" } },
      key: "gov28_5",
      useLabel: false,
    },
    {
      name: "st_18_Environmental Protection Agency",
      label: "Environmental Protection Agency",
      type: "checkbox",
      fieldLableProps: { style: { padding: "0px 0 0px" } },
      key: "gov28_6",
      useLabel: false,
    },
    {
      name: "st_18_Federal Funded Research and Development Centers",
      label: "Federal Funded Research and Development Centers",
      type: "checkbox",
      fieldLableProps: { style: { padding: "0px 0 0px" } },
      key: "gov28_7",
      useLabel: false,
    },
    {
      name: "st_18_Federal Government (Canada)",
      label: "Federal Government (Canada)",
      type: "checkbox",
      fieldLableProps: { style: { padding: "0px 0 0px" } },
      key: "gov28_8",
      useLabel: false,
    },
    {
      name: "st_18_Federal Government (U.S.)",
      label: "Federal Government (U.S.)",
      type: "checkbox",
      fieldLableProps: { style: { padding: "0px 0 0px" } },
      key: "gov28_9",
      useLabel: false,
    },
    {
      name: "st_18_Local/Municipal Government",
      label: "Local/Municipal Government",
      type: "checkbox",
      fieldLableProps: { style: { padding: "0px 0 0px" } },
      key: "gov28_10",
      useLabel: false,
    },
  ],

  section29: [
    {
      name: "st_18_Marine Corps",
      label: "Marine Corps",
      type: "checkbox",
      fieldLableProps: { style: { padding: "0px 0 0px" } },
      key: "gov29_1",
      useLabel: false,
    },
    {
      name: "st_18_NASA",
      label: "NASA",
      type: "checkbox",
      fieldLableProps: { style: { padding: "0px 0 0px" } },
      key: "gov29_2",
      useLabel: false,
    },
    {
      name: "st_18_National Security Agency",
      label: "National Security Agency",
      type: "checkbox",
      fieldLableProps: { style: { padding: "0px 0 0px" } },
      key: "gov29_3",
      useLabel: false,
    },
    {
      name: "st_18_Other Civilian Agencies",
      label: "Other Civilian Agencies",
      type: "checkbox",
      fieldLableProps: { style: { padding: "0px 0 0px" } },
      key: "gov29_4",
      useLabel: false,
    },
    {
      name: "st_18_Other Defense Agencies",
      label: "Other Defense Agencies",
      type: "checkbox",
      fieldLableProps: { style: { padding: "0px 0 0px" } },
      key: "gov29_5",
      useLabel: false,
    },
    {
      name: "st_18_Prime Contractors",
      label: "Prime Contractors",
      type: "checkbox",
      fieldLableProps: { style: { padding: "0px 0 0px" } },
      key: "gov29_6",
      useLabel: false,
    },
    {
      name: "st_18_State Department",
      label: "State Department",
      type: "checkbox",
      fieldLableProps: { style: { padding: "0px 0 0px" } },
      key: "gov29_7",
      useLabel: false,
    },
    {
      name: "st_18_State/Provincial Government",
      label: "State/Provincial Government",
      type: "checkbox",
      fieldLableProps: { style: { padding: "0px 0 0px" } },
      key: "gov29_8",
      useLabel: false,
    },
    {
      name: "st_18_Treasury Department",
      label: "Treasury Department",
      type: "checkbox",
      fieldLableProps: { style: { padding: "0px 0 0px" } },
      key: "gov29_9",
      useLabel: false,
    },
    {
      name: "st_18_All",
      label: "All",
      type: "checkbox",
      fieldLableProps: { style: { padding: "0px 0 0px" } },
      key: "gov29_10",
      useLabel: false,
    },
  ],

  section30: [
    {
      name: "qt_19_textAreaAnswer",
      label:
        "Please list all contracts that can be used by government end users to acquire Adobe products. For each contract, provide the following information: Awarding Agency Name, Contract Number, Dollar Value, and Expiration Date.",
      type: "textarea",
      fieldLableProps: {
        style: { color: "#323232", fontSize: "16.5px" },
        necessity: "required",
      },
      rowStyle: { marginTop: "0.5%", marginBottom: "0.5%" },
      maxLength: 15000,
      required: true,
      validator: "isString",
      placeholder: "Add",
      label_lang: "",
      key: "gov30",
      useLabel: true,
    },
  ],
  section31: [
    {
      name: "qt_20_textAreaAnswer",
      label: "Company Website ",
      label_lang: "",
      type: "textfield",
      fieldLableProps: { style: { fontSize: "13.5px" } },
      maxLength: 81,
      validator: "isString",
      placeholder: "Add",
      key: "gov31",
      useLabel: true,
    },
  ],
  section32: [
    {
      name: "qt_21_textAreaAnswer",
      label:
        "Please identify your company’s additional location/s below. For each location, provide the following information: Office Manager/Contact, Address, Telephone, Fax, Email, Number of Sales Personnel, Number of Technical Personnel, and Total Personnel at this location.",
      type: "textarea",
      fieldLableProps: { style: { color: "#323232", fontSize: "16.5px" } },
      maxLength: 15000,
      validator: "isString",
      placeholder: "Add",
      label_lang: "",
      key: "gov32",
      useLabel: true,
    },
  ],

  section33: [
    {
      type: "radiogroup",
      fieldLableProps: {
        style: { color: "#323232", fontSize: "16.5px" },
        necessity: "required",
      },
      name: "qt_22_ynu",
      required: true,
      key: "gov33_1",
      validator: "isString",
      label:
        "Has your company or any of its principals ever been suspended, debarred, or otherwise excluded from contracting with the government? ",
      useLabel: true,
      rowStyle: { paddingBottom: "1%" },
      radios: [
        {
          label: "Yes",
          value: "Yes",
          type: "radio",
          useLabel: true,
        },
        {
          label: "No",
          value: "No",
          type: "radio",
          useLabel: true,
        },
      ],
      actions: [
        {
          fieldName: "qt-22-checkboxAnswer",
          resetRequired: true,
          untouchRequired: true,
          resetValue: null,
        },
      ],
    },
    {
      type: "radiogroup",
      fieldLableProps: {
        style: { color: "#323232", fontSize: "16.5px" },
        necessity: "required",
      },
      name: "qt_23_ynu",
      required: true,
      key: "gov33_2",
      validator: "isString",
      label:
        "Has your company ever had a government contract terminated for default or for cause? ",
      useLabel: true,
      rowStyle: { paddingBottom: "1%" },
      radios: [
        {
          label: "Yes",
          value: "Yes",
          type: "radio",
          useLabel: true,
        },
        {
          label: "No",
          value: "No",
          type: "radio",
          useLabel: true,
        },
      ],
      actions: [
        {
          fieldName: "qt-23-checkboxAnswer",
          resetRequired: true,
          untouchRequired: true,
          resetValue: null,
        },
      ],
    },
    {
      type: "radiogroup",
      fieldLableProps: {
        style: { color: "#323232", fontSize: "16.5px" },
        necessity: "required",
      },
      name: "qt_24_ynu",
      required: true,
      key: "gov33_3",
      validator: "isString",
      label:
        "Has your company ever been subject to a Department of Justice investigation that led to a prosecution, an indictment, a deferred prosecution agreement, a civil complaint, or a settlement involving the payment of money to the government? ",
      useLabel: true,
      rowStyle: { paddingBottom: "1%" },
      radios: [
        {
          label: "Yes",
          value: "Yes",
          type: "radio",
          useLabel: true,
        },
        {
          label: "No",
          value: "No",
          type: "radio",
          useLabel: true,
        },
      ],
      actions: [
        {
          fieldName: "qt-24-checkboxAnswer",
          resetRequired: true,
          untouchRequired: true,
          resetValue: null,
        },
      ],
    },
  ],
  section34: [
    {
      type: "radiogroup",
      fieldLableProps: {
        style: { color: "#323232", fontSize: "16.5px" },
        necessity: "required",
      },
      name: "qt_25_ynu",
      required: true,
      key: "gov34_1",
      validator: "isString",
      label:
        "Does your company have a written code of business ethics and conduct; and have you made that code available to each employee engaged in the performance of your government contract(s)? ",
      useLabel: true,
      rowStyle: { paddingBottom: "1%" },
      radios: [
        {
          label: "Yes",
          value: "Yes",
          type: "radio",
          useLabel: true,
        },
        {
          label: "No",
          value: "No",
          type: "radio",
          useLabel: true,
        },
      ],
    },
    {
      type: "radiogroup",
      fieldLableProps: {
        style: { color: "#323232", fontSize: "16.5px" },
        necessity: "required",
      },
      name: "qt_26_ynu",
      required: true,
      key: "gov34_2",
      validator: "isString",
      label:
        "Does your company have a system in place to identify, investigate, and disclose to the government, if appropriate, credible evidence of wrongdoing? ",
      useLabel: true,
      rowStyle: { paddingBottom: "1%" },
      radios: [
        {
          label: "Yes",
          value: "Yes",
          type: "radio",
          useLabel: true,
        },
        {
          label: "No",
          value: "No",
          type: "radio",
          useLabel: true,
        },
      ],
    },
    {
      type: "radiogroup",
      fieldLableProps: {
        style: { color: "#323232", fontSize: "16.5px" },
        necessity: "required",
      },
      name: "qt_29_ynu",
      required: true,
      key: "gov34_3",
      validator: "isString",
      label:
        "Does your company maintain an effective training program to ensure that your personnel are knowledgeable regarding the rules and regulations regarding selling to the government? ",
      useLabel: true,
      rowStyle: { paddingBottom: "1%" },
      radios: [
        {
          label: "Yes",
          value: "Yes",
          type: "radio",
          useLabel: true,
        },
        {
          label: "No",
          value: "No",
          type: "radio",
          useLabel: true,
        },
      ],
    },
    {
      type: "radiogroup",
      fieldLableProps: {
        style: { color: "#323232", fontSize: "16.5px" },
        necessity: "required",
      },
      name: "qt_30_ynu",
      required: true,
      key: "gov34_4",
      validator: "isString",
      label:
        "Do you have an internal control system (e.g., policies, procedures, etc.) directed at ensuring full compliance with the terms and conditions of your government contract(s)? ",
      useLabel: true,
      rowStyle: { paddingBottom: "1%" },
      radios: [
        {
          label: "Yes",
          value: "Yes",
          type: "radio",
          useLabel: true,
        },
        {
          label: "No",
          value: "No",
          type: "radio",
          useLabel: true,
        },
      ],
    },
    {
      type: "radiogroup",
      fieldLableProps: {
        style: { color: "#323232", fontSize: "16.5px" },
        necessity: "required",
      },
      name: "qt_31_ynu",
      required: true,
      key: "gov34_5",
      validator: "isString",
      label:
        "To the extent you identify yourself as a small business, have you reassessed your business size within the past year, including issues of affiliation? ",
      useLabel: true,
      rowStyle: { paddingBottom: "1%" },
      radios: [
        {
          label: "Yes",
          value: "Yes",
          type: "radio",
          useLabel: true,
        },
        {
          label: "No",
          value: "No",
          type: "radio",
          useLabel: true,
        },
      ],
    },
  ],

  section35: [
    {
      name: "qt-22-checkboxAnswer",
      label: "If yes, please describe.",
      type: "textarea",
      fieldLableProps: {
        style: { color: "#323232", fontSize: "15px" },
        necessity: "required",
      },
      maxLength: 32000,
      required: true,
      key: "gov35_1",
      validator: "isString",
      placeholder: "Add",
      label_lang: "",
      key: "gov35_1",
      useLabel: true,
      rowStyle: { paddingBottom: "3%" },
    },
    {
      name: "qt-23-checkboxAnswer",
      label: "If yes, please describe.",
      type: "textarea",
      fieldLableProps: {
        style: { color: "#323232", fontSize: "15px" },
        necessity: "required",
      },
      maxLength: 32000,
      required: true,
      key: "gov35_2",
      validator: "isString",
      placeholder: "Add",
      label_lang: "",
      key: "gov35_2",
      useLabel: true,
      rowStyle: { paddingBottom: "3%" },
    },
    {
      name: "qt-24-checkboxAnswer",
      label: "If yes, please describe.",
      type: "textarea",
      fieldLableProps: {
        style: { color: "#323232", fontSize: "15px" },
        necessity: "required",
      },
      maxLength: 32000,
      required: true,
      key: "gov35_3",
      validator: "isString",
      placeholder: "Add",
      label_lang: "",
      useLabel: true,
      rowStyle: { paddingBottom: "3%" },
    },
  ],

  section36: [
    {
      name: "qt-38-checkboxAnswer",
      label:
        "If yes, please provide the agreement type and number, if available.",
      type: "textarea",
      fieldLableProps: { style: { fontSize: "13.5px", color: "#323232" } },
      maxLength: 32000,
      required: true,
      validator: "isString",
      placeholder: "Add",
      label_lang: "",
      key: "gov36",
      useLabel: true,
    },
  ],

  section37: [
    {
      name: "gov37_1",
      type: "divwithspan",
      key: "gov37_1",
      value: "Organization",
      divStyle: { height: "42.2px", paddingTop: "1px" },
      spanStyle: { color: "#747474" },
    },
    {
      name: "gov37_2",
      type: "divwithspan",
      key: "gov37_2",
      value: "Contact Name",
      divStyle: { height: "42.2px" },
      spanStyle: { color: "#747474" },
    },
    {
      name: "gov37_3",
      type: "divwithspan",
      key: "gov37_3",
      value: "Title",
      divStyle: { height: "42.2px" },
      spanStyle: { color: "#747474" },
    },
    {
      name: "gov37_4",
      type: "divwithspan",
      key: "gov37_4",
      value: "Phone",
      divStyle: { height: "42.2px" },
      spanStyle: { color: "#747474" },
    },
    {
      name: "gov37_5",
      type: "divwithspan",
      key: "gov37_5",
      value: "Email address",
      divStyle: { height: "42.2px" },
      spanStyle: { color: "#747474" },
    },
    {
      name: "gov37_6",
      type: "divwithspan",
      key: "gov37_6",
      value: "Address line 1",
      divStyle: { height: "42.2px" },
      spanStyle: { color: "#747474" },
    },
    {
      name: "gov37_7",
      type: "divwithspan",
      key: "gov37_7",
      value: "Address line 2",
      divStyle: { height: "42.2px" },
      spanStyle: { color: "#747474" },
    },
    {
      name: "gov37_8",
      type: "divwithspan",
      key: "gov37_8",
      value: "City",
      divStyle: { height: "42.2px" },
      spanStyle: { color: "#747474" },
    },
    {
      name: "gov37_9",
      type: "divwithspan",
      key: "gov37_9",
      value: "State/Province",
      divStyle: { height: "42.2px" },
      spanStyle: { color: "#747474" },
    },
    {
      name: "gov37_10",
      type: "divwithspan",
      key: "gov37_10",
      value: "Postal code",
      divStyle: { height: "42.2px" },
      spanStyle: { color: "#747474" },
    },
    {
      name: "gov37_11",
      type: "divwithspan",
      key: "gov37_11",
      value: "Country",
      divStyle: { height: "42.2px" },
      spanStyle: { color: "#747474" },
    },
  ],

  section38: [
    {
      name: "qt-36-answer3",
      type: "textfield",
      label: "",
      fieldLableProps: { style: { fontSize: "13.5px" } },
      placeholder: "Organization",
      maxLength: 40,
      required: true,
      validator: "isString",
      key: "gov38_1f",
      useLabel: true,
      rowStyle: { paddingBottom: "10px" },
    },
    {
      name: "qt-36-answer2",
      type: "textfield",
      label: "",
      fieldLableProps: { style: { fontSize: "13.5px" } },
      placeholder: "Contact Name",
      maxLength: 40,
      required: true,
      validator: "isString",
      key: "gov38_2f",
      useLabel: true,
      rowStyle: { paddingBottom: "10px" },
    },
    {
      name: "qt-36-answer1",
      type: "textfield",
      label: "",
      fieldLableProps: { style: { fontSize: "13.5px" } },
      maxLength: 80,
      placeholder: "Title",
      required: true,
      validator: "isString",
      key: "gov38_3f",
      useLabel: true,
      rowStyle: { paddingBottom: "10px" },
    },
    {
      name: "qt-36-answer10",
      type: "textfield",
      label: "",
      fieldLableProps: { style: { fontSize: "13.5px" } },
      required: true,
      maxLength: 80,
      validator: "isValidPhoneNumber",
      placeholder: "Phone",
      key: "gov38_4f",
      useLabel: true,
      rowStyle: { paddingBottom: "10px" },
    },
    {
      name: "qt-36-answer11",
      type: "textfield",
      label: "",
      maxLength: 80,
      fieldLableProps: { style: { fontSize: "13.5px" } },
      required: true,
      validator: "isEmail",
      placeholder: "Email address",
      key: "gov38_5f",
      useLabel: true,
      rowStyle: { paddingBottom: "10px" },
    },
    {
      name: "qt-36-answer4",
      type: "textfield",
      label: "",
      fieldLableProps: { style: { fontSize: "13.5px" } },
      maxLength: 80,
      required: true,
      validator: "isString",
      placeholder: "Address line 1",
      key: "gov38_6f",
      useLabel: true,
      rowStyle: { paddingBottom: "10px" },
    },
    {
      name: "qt-36-answer5",
      type: "textfield",
      label: "",
      fieldLableProps: { style: { fontSize: "13.5px" } },
      maxLength: 80,
      placeholder: "Address line 2",
      key: "gov38_7f",
      useLabel: true,
      rowStyle: { paddingBottom: "10px" },
    },
    {
      name: "qt-36-answer6",
      type: "textfield",
      label: "",
      fieldLableProps: { style: { fontSize: "13.5px" } },
      maxLength: 40,
      required: true,
      validator: "isString",
      placeholder: "City",
      key: "gov38_8f",
      useLabel: true,
      rowStyle: { paddingBottom: "10px" },
    },
    {
      name: "qt-36-answer7",
      type: "textfield",
      label: "",
      fieldLableProps: { style: { fontSize: "13.5px" } },
      maxLength: 40,
      required: true,
      validator: "isString",
      placeholder: "State/Province",
      key: "gov38_9f",
      useLabel: true,
      rowStyle: { paddingBottom: "10px" },
    },
    {
      name: "qt-36-answer8",
      type: "textfield",
      label: "",
      fieldLableProps: { style: { fontSize: "13.5px" } },
      maxLength: 20,
      required: true,
      validator: "isString",
      placeholder: "Postal Code",
      key: "gov38_10f",
      useLabel: true,
      rowStyle: { paddingBottom: "10px" },
    },
    {
      name: "qt-36-answer9",
      type: "textfield",
      label: "",
      fieldLableProps: { style: { fontSize: "13.5px" } },
      key: "gov38_11f",
      required: true,
      validator: "isString",
      maxLength: 80,
      placeholder: "Country",
      useLabel: true,
      rowStyle: { paddingBottom: "10px" },
    },
  ],
  section39: [
    {
      name: "terms",
      label: "",
      type: "checkbox",
      key: "gov39",
      required: true,
      useLabel: true,
      renderLabel: false,
      fieldLableProps: { style: { padding: "0px 0 0px" } },
    },
  ],

  section40: [
    {
      type: "none",
      fieldLableProps: {
        style: { color: "#323232", fontSize: "16.5px" },
        necessity: "required",
      },
      name: "span1",
      label: "Number of employees (enter 0 if not applicable)",
      key: "govtext11",
      useLabel: true,
    },
    {
      type: "none",
      fieldLableProps: {
        style: { color: "#323232", fontSize: "16px" },
        necessity: "required",
      },
      name: "span2",
      key: "govtext12",
      label:
        "Please provide the contact information of four (4) sales representatives dedicated to the government sector (Federal, State, Local, and/or Provincial government)",
      useLabel: true,
    },
    {
      type: "none",
      fieldLableProps: { style: { color: "#323232", fontSize: "16.5px" } },
      name: "span3",
      key: "govtext13",
      label: "How would you classify your company?",
      useLabel: true,
    },
    {
      type: "none",
      fieldLableProps: { style: { color: "#323232", fontSize: "16.5px" } },
      name: "span4",
      key: "govtext14",
      label:
        "Provide three (3) customer references who are currently utilizing your solution.",
      useLabel: true,
    },
    {
      type: "none",
      fieldLableProps: {
        style: { color: "rgb(110, 110, 110)", fontSize: "15px" },
        necessity: "required",
      },
      name: "span5",
      key: "govtext15",
      label:
        "Company total IT-related revenues for the most recent calendar year (January - December):",
      useLabel: true,
    },
    {
      type: "none",
      fieldLableProps: {
        style: { color: "#323232", fontSize: "16.5px" },
        necessity: "required",
      },
      name: "span6",
      key: "govtext16",
      label:
        "List approximate percentage of revenue by type (percentages should total 100% and enter zero if not applicable):",
      useLabel: true,
    },
    {
      type: "none",
      fieldLableProps: {
        style: { color: "#323232", fontSize: "16.5px" },
        necessity: "required",
      },
      name: "span7",
      key: "govtext17",
      label:
        "What percentage of your revenue is derived from sales to the following market segments? (Enter zero if not applicable)",
      useLabel: true,
    },
    {
      type: "none",
      fieldLableProps: {
        style: { color: "#323232", fontSize: "16.5px" },
        necessity: "required",
      },
      name: "span8",
      key: "govtext18",
      label:
        "List the top three (3) other industry-leading software that your firm sells (enter zero if not applicable).",
      useLabel: true,
    },
    {
      type: "none",
      fieldLableProps: {
        style: { color: "#323232", fontSize: "16.5px" },
        necessity: "required",
      },
      name: "span9",
      key: "govtext19",
      label:
        "List your top three (3) industry markets (enter zero if not applicable).",
      useLabel: true,
    },
    {
      type: "none",
      fieldLableProps: {
        style: { color: "#323232", fontSize: "16.5px" },
        necessity: "required",
      },
      name: "span10",
      key: "govtext110",
      label:
        "From the list below, please identify the specific government end users to whom you currently sell.",
      useLabel: true,
    },
    {
      type: "none",
      fieldLableProps: {
        style: { color: "#323232", fontSize: "16.5px" },
        necessity: "required",
      },
      name: "span11",
      key: "govtext111",
      label:
        "Please attach one set of your company’s standard promotional brochure/s. This information should reflect your value add as a channel partner and your company’s general business direction and goals.",
      useLabel: true,
    },
  ],

  section41: [
    [
      {
        name: "qt-10-answer1-0",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        placeholder: "Name",
        maxLength: 40,

        key: "gov8_cr1c0",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-10-answer2-0",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 80,
        placeholder: "Title",

        key: "gov8_cr2c0",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-10-answer9-0",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 80,

        placeholder: "Phone",
        key: "gov8_cr3c0",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-10-answer10-0",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 80,
        validator: "isEmail",
        placeholder: "Email address",
        key: "gov8_cr4c0",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-10-answer3-0",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 80,

        placeholder: "Address line 1",
        key: "gov8_cr5c0",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-10-answer4-0",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 80,
        placeholder: "Address line 2",
        key: "gov8_cr6c0",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-10-answer5-0",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 40,

        placeholder: "City",
        key: "gov8_cr7c0",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-10-answer6-0",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 40,

        placeholder: "State/Province",
        key: "gov8_cr8c0",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-10-answer7-0",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 20,

        placeholder: "Postal Code",
        key: "gov8_cr9c0",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-10-answer8-0",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        key: "gov8_cr10c0",
        maxLength: 80,

        placeholder: "Country",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
    ],
    [
      {
        name: "qt-10-answer1-1",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        placeholder: "Name",
        maxLength: 40,

        key: "gov8_cr1c1",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-10-answer2-1",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 80,
        placeholder: "Title",

        key: "gov8_cr2c1",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-10-answer9-1",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 80,

        placeholder: "Phone",
        key: "gov8_cr3c1",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-10-answer10-1",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 80,
        validator: "isEmail",
        placeholder: "Email address",
        key: "gov8_cr4c1",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-10-answer3-1",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 80,

        placeholder: "Address line 1",
        key: "gov8_cr5c1",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-10-answer4-1",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 80,
        placeholder: "Address line 2",
        key: "gov8_cr6c1",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-10-answer5-1",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 40,

        placeholder: "City",
        key: "gov8_cr7c1",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-10-answer6-1",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 40,

        placeholder: "State/Province",
        key: "gov8_cr8c1",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-10-answer7-1",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 20,

        placeholder: "Postal Code",
        key: "gov8_cr9c1",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-10-answer8-1",
        type: "textfield",
        label: "",
        maxLength: 80,
        fieldLableProps: { style: { fontSize: "13.5px" } },
        key: "gov8_cr10c1",

        placeholder: "Country",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
    ],

    [
      {
        name: "qt-10-answer1-2",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        placeholder: "Name",
        maxLength: 40,

        key: "gov8_cr1c2",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-10-answer2-2",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 80,
        placeholder: "Title",

        key: "gov8_cr2c2",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-10-answer9-2",
        type: "textfield",
        label: "",
        maxLength: 80,
        fieldLableProps: { style: { fontSize: "13.5px" } },

        placeholder: "Phone",
        key: "gov8_cr3c2",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-10-answer10-2",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 80,
        validator: "isEmail",
        placeholder: "Email address",
        key: "gov8_cr4c2",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-10-answer3-2",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 80,

        placeholder: "Address line 1",
        key: "gov8_cr5c2",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-10-answer4-2",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 80,
        placeholder: "Address line 2",
        key: "gov8_cr6c2",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-10-answer5-2",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 40,

        placeholder: "City",
        key: "gov8_cr7c2",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-10-answer6-2",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 40,

        placeholder: "State/Province",
        key: "gov8_cr8c2",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-10-answer7-2",
        type: "textfield",
        label: "",
        fieldLableProps: { style: { fontSize: "13.5px" } },
        maxLength: 20,

        placeholder: "Postal Code",
        key: "gov8_cr9c2",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
      {
        name: "qt-10-answer8-2",
        type: "textfield",
        label: "",
        maxLength: 80,
        fieldLableProps: { style: { fontSize: "13.5px" } },
        key: "gov8_cr10c2",

        placeholder: "Country",
        useLabel: true,
        rowStyle: { paddingBottom: "10px" },
      },
    ],
  ],
};
